/* ============================================================
   Pills & Powders — thank-you page rewards link  (Stage-1)

   Haakon 2026-06-12 (v2). Fetches the voter's REAL GoAffPro
   referral link from the Make webhook and hands it to the
   pp-postvote section via window.ppSetRewardsLink(), which
   updates the visible URL, both copy buttons, and every share
   button in one pass.

   Flow:
     1. vote-capture.js stores pp_vote_email / pp_vote_name
        (15-min cookies) at submit, and fires the vote payload
        to Make (fire-and-forget) so the affiliate usually
        already exists by the time this runs.
     2. This script (loaded by pp-postvote.liquid, defer) reads
        the voter's email and POSTs it to the same Make webhook.
     3. Make creates-or-finds the affiliate and responds with the
        referral link as JSON, e.g.
        { "referalCode": "https://pillsandpowders.com/?ref=XXXX" }
     4. window.ppSetRewardsLink(link) swaps the placeholder
        everywhere.

   Failure mode: missing email, webhook error, or no link in the
   response -> placeholder stays, page never breaks.

   [EMRE/HAAKON FIX 2026-06-12] Three robustness changes, all on
   the page side, Haakon's architecture + the Make contract kept:
     (a) Email source no longer depends on a single wipeable cookie.
         It is now read from the redirect URL (?e=) FIRST, with the
         pp_vote_email cookie as fallback. The /vote redirect now
         carries ?e= (see sections/pp-vote-real.liquid), so even if
         a Clear-Site-Data / app script clears the cookie, the email
         still reaches this script.
     (b) Response parsing is tolerant: it accepts the link under any
         of a few key names, or as a raw URL string, so a small Make
         output tweak does not silently break the swap. It also no
         longer crashes on a non-JSON ack (e.g. "Accepted").
     (c) A short bounded retry covers the case where the affiliate is
         still being created when this first runs.
   Opt-in debug: add ?ppdebug=1 to the URL to see each step in the
   console. Off by default so production stays clean.
   ============================================================ */

(function () {
  var HOOK = "https://hook.eu1.make.com/sq93uj54r3wokc1ha2ul18qjthksvk9t";
  var MAX_ATTEMPTS = 3;       // affiliate may still be creating on first load
  var RETRY_MS = 2000;

  var params = new URLSearchParams(window.location.search);
  var DEBUG = params.get("ppdebug") === "1";
  function log() { if (DEBUG && window.console) console.log.apply(console, ["[rewards-link]"].concat([].slice.call(arguments))); }

  function cookie(n) {
    var m = document.cookie.match(new RegExp("(?:^|;\\s*)" + n + "=([^;]+)"));
    return m ? decodeURIComponent(m[1]) : "";
  }

  // [EMRE/HAAKON FIX 2026-06-12] URL param first, cookie fallback.
  var email = (params.get("e") || "").trim() || cookie("pp_vote_email");
  // If the referral link came through the redirect URL, use it directly.
    var directLink = (params.get("ref") || "").trim();
    if (directLink && typeof window.ppSetRewardsLink === "function") {
      window.ppSetRewardsLink(directLink);
      return; // no Make fetch needed
    }
  var name = (params.get("n") || "").trim() || cookie("pp_vote_name");
  if (!email) { log("no email in URL or cookie -> leave placeholder"); return; }
  log("email source ok:", email);

  // Pull a usable referral URL out of whatever shape Make returns.
  function extractLink(raw) {
    if (!raw) return "";
    var obj = null;
    if (typeof raw === "object") {
      obj = raw;
    } else if (typeof raw === "string") {
      var s = raw.trim();
      if (s.indexOf("http") === 0) return s;            // raw URL body
      try { obj = JSON.parse(s); } catch (e) { return ""; } // e.g. "Accepted" -> ""
    }
    if (!obj || typeof obj !== "object") return "";
    var keys = ["referalCode", "referralCode", "ref", "link", "url",
                "share_link", "shareLink", "affiliate_link", "affiliateLink"];
    for (var i = 0; i < keys.length; i++) {
      var v = obj[keys[i]];
      if (typeof v === "string" && v.indexOf("http") === 0) return v.trim();
    }
    return "";
  }

  function attempt(n) {
    log("attempt", n, "->", HOOK);
    fetch(HOOK, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: email, firstname: name })
    })
      .then(function (r) { return r.text(); })
      .then(function (txt) {
        var link = extractLink(txt);
        log("response:", JSON.stringify(txt).slice(0, 200), "-> link:", link || "(none)");
        if (link) {
          if (typeof window.ppSetRewardsLink === "function") {
            window.ppSetRewardsLink(link);
            log("swapped placeholder with real link");
          }
          return;
        }
        if (n < MAX_ATTEMPTS) {
          setTimeout(function () { attempt(n + 1); }, RETRY_MS);
        } else {
          log("no link after", MAX_ATTEMPTS, "attempts -> placeholder stays");
        }
      })
      .catch(function (err) {
        log("fetch error:", String(err));
        if (n < MAX_ATTEMPTS) setTimeout(function () { attempt(n + 1); }, RETRY_MS);
      });
  }

  attempt(1);
})();
